import { LoginResponseType } from "../../Types/Authentication/LoginTypes";

const isTrueValue = (value: unknown) => {
  if (typeof value === "boolean") return value;
  if (typeof value === "string") return value.trim().toLowerCase() === "true";
  return false;
};

export const hasAiAccess = (user: LoginResponseType | null | undefined) => {
  if (!user) return false;

  if (isTrueValue(user.ai)) return true;

  if (!user.grant || typeof user.grant !== "string") return false;
  try {
    const parsedGrant = JSON.parse(user.grant) as { ai?: string | boolean };
    return isTrueValue(parsedGrant?.ai);
  } catch {
    return false;
  }
};

